import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { loginMobile, verifyOtp } from "./api";

function Auth(props) {
  const [mobileNumber, setmobileNumber] = useState("");
  const [otp, setotp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  return (
    <div
      style={{
        height: "100vh",
        margin: "0 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <form>
        <div>
          <input
            placeholder="Mobile Number"
            value={mobileNumber}
            onChange={(e) => setmobileNumber(e.target.value)}
          />
        </div>
        {showOtp ? (
          <div>
            <input
              placeholder="OTP"
              value={otp}
              onChange={(e) => setotp(e.target.value)}
            />
          </div>
        ) : null}
        <button
          type="submit"
          onClick={async (e) => {
            e.preventDefault();
            if (!showOtp) {
              const status = await loginMobile(mobileNumber);
              setShowOtp(status);
            } else {
              const status = await verifyOtp(mobileNumber, otp);
              console.log(status);
              // redirect
              if (status) {
                props.history.push("/");
              }
            }
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
}
export default withRouter(Auth);
